import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/* Root component */
import { BookingComponent } from './features/booking/booking.component';

/* Children components */
import { SearchTypeSelectionComponent } from './features/booking/pages/search-type-selection/search-type-selection.component';
import { SelectDatetimeComponent } from './features/booking/pages/select-datetime/select-datetime.component';
import { SelectPlantComponent } from './features/booking/pages/select-plant/select-plant.component';
import { PreBookingComponent } from './features/booking/pages/pre-booking/pre-booking.component';
import { PersonalInformationComponent } from './features/booking/pages/personal-information/personal-information.component';
import { BookingConfirmedComponent } from './features/booking/pages/booking-confirmed/booking-confirmed.component';
import { PaymentComponent } from './features/booking/pages/payment/payment.component';
import { ChangeBookingComponent } from './features/booking/pages/change-booking/change-booking.component';
import { DatetimeChangeBookingComponent } from './features/booking/pages/datetime-change-booking/datetime-change-booking.component';
import { EndingBookingComponent } from './features/booking/pages/ending-booking/ending-booking.component';

/* Not found/Error component */
import { ErrorsComponent } from './features/errors-component/errors.component';

const routes: Routes = [
  { path: '', redirectTo: '/booking/search-type', pathMatch: 'full' },
  { path: 'booking', redirectTo: '/booking/search-type', pathMatch: 'full' },
  {
    path: 'booking',
    component: BookingComponent,
    children: [
      { path: 'search-type', component: SearchTypeSelectionComponent },
      { path: 'select-datetime', component: SelectDatetimeComponent },
      { path: 'pre-booking', component: PreBookingComponent },
      { path: 'personal-information', component: PersonalInformationComponent },
      { path: 'select-plant', component: SelectPlantComponent },
      { path: 'booking-confirmed', component: BookingConfirmedComponent },
      { path: 'payment', component: PaymentComponent },
      { path: 'change-booking', component: ChangeBookingComponent },
      { path: 'date-change-booking', component: DatetimeChangeBookingComponent },
      { path: 'error', component: ErrorsComponent },
      { path: 'ending-booking', component: EndingBookingComponent },
      { path: 'ending-booking/:planta', component: EndingBookingComponent },
      { path: 'ending-booking/payment/:reservation_code', component: EndingBookingComponent }
    ]
  },
  { path: '**', component: ErrorsComponent }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)]
})
export class AppRoutingModule { }
